import {
  Component,
  computed,
  effect,
  // Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import {
//   MSAL_GUARD_CONFIG,
//   MsalBroadcastService,
//   MsalGuardConfiguration,
//   MsalService,
// } from '@azure/msal-angular';
// import {
//   AuthenticationResult,
//   EventMessage,
//   EventType,
//   InteractionStatus,
//   PopupRequest,
//   RedirectRequest,
// } from '@azure/msal-browser';
import {
  CommonService,
  IndexedDBService,
  TenantService,
  UserDataService,
} from '@via/services';
import { LicenseManager } from 'ag-grid-enterprise';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { SidebarService } from './shared-global/modules/sidebar/sidebar.service';

@Component({
  selector: 'via-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  readonly spinnerTemplate = `
    <div>
      <span class="letters-flashing color-primary">
        <span>O</span>
        <span>U</span>
        <span>T</span>
        <span>A</span>
        <span>M</span>
        <span>A</span>
        <span>T</span>
        <span>E</span>
      </span>
      <div class="dot-flashing">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  `;
  private readonly _destroying$ = new Subject<void>();

  // TODO: Use route guard in the future instead of effect
  public showTenant = computed(
    () =>
      !this.tenantService.currentTenant() &&
      !!this.tenantService.tenants().length
  );
  public showUnauthorize = computed(() => !this.tenantService.tenants());

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    // private authService: MsalService,
    private tenantService: TenantService,
    // private msalBroadcastService: MsalBroadcastService,
    private commonService: CommonService,
    private userDataService: UserDataService,
    private sidebarService: SidebarService,
    private indexedDBService: IndexedDBService
    // @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {
    this.primengConfig.ripple = true;
    LicenseManager.setLicenseKey(environment.AG_GRID_LICENSE_KEY);

    effect(() => {
      if (this.showUnauthorize()) {
        this.router.navigate(['app/unauthorized']);
      }
      if (this.showTenant()) {
        this.router.navigate(['app/tenant-configuration']);
      }
    });
  }

  async ngOnInit() {
    await this.indexedDBService.removeExpiredDocuments();
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        const rt = this.commonService.getActivatedRouteChild(this.route);
        if (this.showTenant()) {
          this.router.navigate(['app/tenant-configuration']);
        }
        if (this.showUnauthorize()) {
          this.router.navigate(['app/unauthorized']);
        }
        rt.data.subscribe((data: any) => {
          this.titleService.setTitle(data?.['title'] || '');
        });
      });

    if (environment.IsSSO) {
      // this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
      // this.msalBroadcastService.msalSubject$
      //   .pipe(
      //     filter(
      //       (msg: EventMessage) =>
      //         msg.eventType === EventType.ACCOUNT_ADDED ||
      //         msg.eventType === EventType.ACCOUNT_REMOVED
      //     )
      //   )
      //   .subscribe(() => {
      //     if (!this.authService.instance.getAllAccounts().length) {
      //       this.router.navigate(['/']);
      //     }
      //   });
      // this.msalBroadcastService.inProgress$
      //   .pipe(
      //     filter(
      //       (status: InteractionStatus) => status === InteractionStatus.None
      //     ),
      //     takeUntil(this._destroying$)
      //   )
      //   .subscribe(() => {
      //     this.checkAndSetActiveAccount();
      //     if (this.authService.instance.getAllAccounts().length) {
      //       this.userDataService.fetchLoggedInUserDetails();
      //     }
      //   });
    } else {
      // this.userDataService.fetchLoggedInUserDetails();
    }
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  /**
   * If no active account set but there are accounts signed in, sets first account to active account
   * To use active account set here, subscribe to inProgress$ first in your component
   * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
   */
  checkAndSetActiveAccount() {
    // const activeAccount = this.authService.instance.getActiveAccount();
    // if (
    //   !activeAccount &&
    //   this.authService.instance.getAllAccounts().length > 0
    // ) {
    //   const accounts = this.authService.instance.getAllAccounts();
    //   this.authService.instance.setActiveAccount(accounts[0]);
    // }
  }

  loginRedirect() {
    if (environment.IsSSO) {
      // if (this.msalGuardConfig.authRequest) {
      //   this.authService.loginRedirect({
      //     ...this.msalGuardConfig.authRequest,
      //   } as RedirectRequest);
      // } else {
      //   this.authService.loginRedirect();
      // }
    }
  }

  loginPopup() {
    // if (this.msalGuardConfig.authRequest) {
    //   this.authService
    //     .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
    //     .subscribe((response: AuthenticationResult) => {
    //       this.authService.instance.setActiveAccount(response.account);
    //     });
    // } else {
    //   this.authService
    //     .loginPopup()
    //     .subscribe((response: AuthenticationResult) => {
    //       this.authService.instance.setActiveAccount(response.account);
    //     });
    // }
  }

  // logout(popup?: boolean) {
  logout() {
    // if (popup) {
    //   this.authService.logoutPopup({
    //     mainWindowRedirectUri: '/',
    //   });
    // } else {
    //   this.authService.logoutRedirect();
    // }
  }
}
